export default function NoData (): JSX.Element {
    return (
        <span className="no-data">
            No hay arreglo programado
        </span>
    );
}
